<template>
   <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="应用版本名称">
              <a-input v-model="query.versionCode" placeholder="请输入应用版本名称" allow-clear />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <span slot="action" slot-scope="text, record">
        <a @click="edit(record)" v-action:edit>编辑</a> 
      </span>
    </a-table>
    <a-modal title="操作" style="top: 20px" :width="800" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel" :confirmLoading="submitLoading">

      <a-form class="log-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用文件">
          <a-upload
            name="file"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :remove="handleRemove"
            accept=".apk"
            :show-upload-list="true"
            :multiple="false"
          >
            <a-button>
              <a-icon type="upload" /> 选择APK文件
            </a-button>
            <div slot="tip" class="ant-upload-hint">
              只能上传APK文件，且不超过100MB
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用版本号">
          <a-input
            v-decorator="['versionCode', { rules: [{ required: true, message: '请输入应用版本号' }] }]" />
        </a-form-item> 
      
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用更新描述">
          <a-textarea placeholder="应用更新描述" v-decorator="['updateLog']" :auto-size="{ minRows: 4 }" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-textarea placeholder="备注" v-decorator="['notes']" :auto-size="{ minRows: 4 }" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'

const columns = [
{
    title: '应用版本号',
    dataIndex: 'versionCode',
    width: 120,

  },
  {
    title: '应用更新描述',
    dataIndex: 'updateLog',
  },
  {
    title: '应用下载地址',
    dataIndex: 'downloadUrl'
  },

  {
    title: '备注',
    dataIndex: 'notes',
    width: 120,
  },

  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',

    width: 150,
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'LogList',
  data () {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      currentId: '',
      deleteUrl  : '/meter-manager/version/batch',
      queryUrl  : '/meter-manager/version/page',
      addOrUpdateUrl: '/meter-manager/version/upload',
      query: {
        versionCode: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      selectedRows: [],
      fileList: [], // 文件列表
      uploadFile: null, // 上传的文件对象
      isUpdate: false, // 是否为编辑模式
      submitLoading: false // 提交加载状态
    }
  },

  created () { },
  methods: {
    // 重置
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {}
      }
      this.selectedRows = []

      this.queryList()
    },
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query
      }

      params.pageNum = this.pagination.current

      params.pageSize = this.pagination.pageSize


      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.selectedRows = []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    }, 

    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (values.status === true) {
          values.status = '1'
        } else if (values.status === false) {
          values.status = '2'
        }
        if (!err) {
          // 检查是否上传了文件（新增时必填，编辑时可选）
          if (!this.uploadFile && !this.currentId) {
            this.$message.error('请选择APK文件')
            return
          }

          // 设置加载状态
          this.submitLoading = true

          // 创建FormData对象用于文件上传
          const formData = new FormData()
          
          // 添加文件
          if (this.uploadFile) {
            formData.append('file', this.uploadFile)
          }
          
          // 添加其他表单数据
          Object.keys(values).forEach(key => {
            if (key !== 'downloadAddress') { // 排除原来的下载地址字段
              formData.append(key, values[key])
            }
          })
          
          // 添加ID（编辑模式）
          if (this.currentId) {
            formData.append('id', this.currentId)
          }

          // 发送请求
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then((res) => {
              this.submitLoading = false
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.fileList = []
                this.uploadFile = null
                this.queryList()
                return this.$message.success(res.message)
              } else {
                this.$message.error(res.message || '操作失败')
              }
            })
            .catch((error) => { 
              this.submitLoading = false
              console.error('操作失败:', error)
              this.$message.error('操作失败，请重试')
            })
        }
      })
    },


    // 文件上传前的验证
    beforeUpload (file) {
      const isAPK = file.type === 'application/vnd.android.package-archive' || file.name.endsWith('.apk')
      if (!isAPK) {
        this.$message.error('只能上传APK文件!')
        return false
      }
      const isLt100M = file.size / 1024 / 1024 < 100
      if (!isLt100M) {
        this.$message.error('文件大小不能超过100MB!')
        return false
      }
      
      // 保存文件对象
      this.uploadFile = file
      
      // 更新文件列表显示
      this.fileList = [{
        uid: file.uid,
        name: file.name,
        status: 'done',
        url: URL.createObjectURL(file)
      }]
      
      return false // 阻止自动上传，手动处理
    },

    // 移除文件
    handleRemove (file) {
      this.fileList = []
      this.uploadFile = null
    },
    statusChange (e) {
      if (e.status === '2') {
        e.status = '1'
      } else {
        e.status = '2'
      }
      this.$http.put(this.addOrUpdateUrl, e).then((res) => {
        if (res.code === 0) {
          this.$message.success(res.message)
          this.resetList()
        } else {
          this.$message.error('修改失败')
        }
      })
    },
    detailInfo (record) {
      this.detailForm = { ...record }
    },
    edit (record) { 
      this.isUpdate = true
      this.currentId = record.id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      // 清空文件列表
      this.fileList = []
      this.uploadFile = null
      this.$nextTick(() => {
        this.addOrUpdateForm.setFieldsValue(record)
      })
    },
    // handleOk() {

    // },
    handleCancel () {
      // 清空文件列表
      this.fileList = []
      this.uploadFile = null
      // 重置加载状态
      this.submitLoading = false
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
